import { markUiObject as __markUi } from '@/i18n/display'
import { consolidateCategoryMenus, isBranchPlatformOnlyFunction, isRetiredPlatformMenu, isPlatformSuperAdministrator } from './platformAdministration'
export interface FunctionSearchItem { id: string; title: string; group: string; path: string; description: string }
export function buildFunctionSearch(functions: any[], parents: any[], user: any, title: (key: string, fallback: string) => string, descriptions: Readonly<Record<string, string>>, canOpen: (path: string) => boolean): FunctionSearchItem[] {
  const source = consolidateCategoryMenus((Array.isArray(functions) ? functions : []).filter(item => item && !Number(item.disabled || 0)
    && !isRetiredPlatformMenu(user, item) && !isBranchPlatformOnlyFunction(user, item)
    && (!['platform.orgrights', 'system.maintenance'].includes(item.functionKey) || isPlatformSuperAdministrator(user))))
  const byId = new Map([...(parents || []), ...source].map(item => [String(item.id), item]))
  const menus = source.filter(item => item.functionType === 'MENU' && /^\/(?!\/)/.test(item.functionUrl || '') && !/[\\\s]/.test(item.functionUrl) && canOpen(item.functionUrl))
  const results: FunctionSearchItem[] = [], seen = new Set<string>()
  for (const item of source) {
    let menu = menus.find(menu => menu === item), current = item
    const visited = new Set<string>()
    while (!menu && current && !visited.has(String(current.id))) {
      visited.add(String(current.id)); current = byId.get(String(current.parentId)); menu = menus.find(menu => menu === current)
    }
    if (!menu) continue
    const path = menu.functionUrl, name = title(item.functionKey, item.functionName), menuName = title(menu.functionKey, menu.functionName)
    const id = name + ':' + path
    if (!name || seen.has(id)) continue
    seen.add(id)
    const parent = byId.get(String(menu.parentId))
    results.push({ id, title: name, path, group: [parent && title(parent.functionKey, parent.functionName), item === menu ? '' : menuName].filter(Boolean).join(' / '), description: item === menu ? descriptions[path] || '' : '进入' + menuName + '，按页面入口操作' })
  }
  const info = menus.find(item => item.functionUrl === '/platform/platforminfo')
  if (info) {
    const sections = [
      __markUi({ title: '机构信息', section: 'org', permission: 'editOrgInfo' }, {"title":"机构信息"}),
      __markUi({ title: '客户端页面设置', section: 'client-pages', permission: 'editOrgInfo' }, {"title":"客户端页面设置"}),
      __markUi({ title: '微信支付', section: 'payment', permission: 'wechatpay' }, {"title":"微信支付"}),
      __markUi({ title: '分账账户', section: 'sharing', permission: 'profitsharing' }, {"title":"分账账户"})
    ]
    for (const section of sections) if (source.some(item => item.functionKey === section.permission)) {
      const path = info.functionUrl + '?section=' + section.section
      results.push({ id: path, title: section.title, path, group: title(info.functionKey, info.functionName), description: '直接打开' + section.title + '栏目' })
    }
  }
  return results
}
export function searchFunctions(items: FunctionSearchItem[], query: string): FunctionSearchItem[] {
  const words = query.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean)
  if (!words.length) return items
  return items.filter(item => words.every(word => [item.title, item.group, item.description].join(' ').toLocaleLowerCase().includes(word)))
    .map((item, index) => ({ item, index, rank: item.title.toLocaleLowerCase() === query.trim().toLocaleLowerCase() ? 0 : words.every(word => item.title.toLocaleLowerCase().includes(word)) ? 1 : 2 }))
    .sort((a, b) => a.rank - b.rank || a.index - b.index).map(row => row.item)
}
